let defaultInfo = {
  auditStatus:'',
  authorities:'',
  createTime:'',
  custLvl:'',
  custSource:'',
  custStatus:'',
  custType:'',
  email:"",
  enabled:'',
  hierarchy:'',
  id:'',
  phone:"",
  savedate:'',
  timeout:'',
  username:"",
  firstName: '',
  portraitImg: ''
};
const user = {
  state: {
    userInfo: defaultInfo,
    // 出金时的信息
    payUserInfo: null,
    subIbJumpToAccountListOfId: 0,
    withdrawAccount: '',
    depositAccount: '',
    noticeDialogShow: false,
    noticeDialogInfo:{
      id: '',
      title: '',
      updateTime: '',
      content: ''
    },

    withdrawDefaultPageTitle: '',
    withdrawDefaultType: 1,
    agentRole: localStorage.getItem('agentRole') || 'CUSTOMER',// IB或者CUSTOMER
  },

  mutations: {
    setUserInfo(state,userInfo){
        state.userInfo = userInfo;
    },
    setLocalUserInfo(state,userInfo){
        state.userInfo = userInfo;
    },
    clearUserInfo(state){
      state.userInfo = null;
    },
    // 出金时的信息
    setPayUserInfo(state,payUserInfo){
      state.payUserInfo = payUserInfo;
    },
    setSubIbJumpToAccountListOfId(state,subIbJumpToAccountListOfId){
      state.subIbJumpToAccountListOfId = subIbJumpToAccountListOfId;
    },
    setWithdrawAccount(state,withdrawAccount){
      state.withdrawAccount = withdrawAccount;
    },
    setDepositAccount(state,depositAccount){
      state.depositAccount = depositAccount;
    },
    setNoticeDialogShow(state,falg){
      state.noticeDialogShow = falg;
    },
    setNoticeDialogInfo(state,info){
      state.noticeDialogInfo = info;
    },
    setWithdrawDefaultPageTitle(state,withdrawDefaultPageTitle){
      state.withdrawDefaultPageTitle = withdrawDefaultPageTitle;
    },
    setWithdrawDefaultType(state,withdrawDefaultType){
      state.withdrawDefaultType = withdrawDefaultType;
    },
    setAgentRole(state,agentRole){
      state.agentRole = agentRole;
    },
  },

  actions: {
  },
  getters:{
    userInfo: state => state.userInfo,
    // 出金时的信息
    payUserInfo: state => state.payUserInfo,
    subIbJumpToAccountListOfId: state => state.subIbJumpToAccountListOfId,
    withdrawAccount: state => state.withdrawAccount,
    depositAccount: state => state.depositAccount,
    localUserInfo: state => state.localUserInfo,
    noticeDialogShow: state => state.noticeDialogShow,
    noticeDialogInfo: state => state.noticeDialogInfo,
    withdrawDefaultPageTitle: state => state.withdrawDefaultPageTitle,
    withdrawDefaultType: state => state.withdrawDefaultType,

    agentRole: state => state.agentRole,// 代理用户当前的角色
  }
};

export default user;
